import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		minHeight: 0,
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column-reverse',
		marginTop: 36,

		'@media (min-width: 722px)': {
			marginTop: 0,
			display: 'grid',
			gridTemplateColumns: '1fr',
			gap: 40,
		},
		marginBottom: THEME.spacing.xl,
	},
	containerWithImage: {
		display: 'flex',
		flexDirection: 'column-reverse',
		gap: 40,
		minHeight: 0,
		minWidth: 0,

		'@media (min-width: 722px)': {
			marginTop: 0,
			display: 'grid',
			gridTemplateColumns: '1fr 1fr',
		},
	},
	imageContainer: {
		width: '100%',
		height: '100%',
		minWidth: 0,
	},
	image: {
		border: THEME.common.border,
		width: '100%',
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 20,
	},
	contentContainerWithImage: {
		'@media (min-width: 722px)': {
			alignItems: 'flex-start',
		},
	},
	title: {
		fontSize: 24,
		fontWeight: 600,
		margin: 0,

		'@media (min-width: 722px)': {
			textAlign: 'start',
		},
	},
	description: {
		fontSize: 16,
		whiteSpace: 'pre-wrap',

		'@media (min-width: 722px)': {
			textAlign: 'start',
		},
	},
});
